"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFee = void 0;
var _react = require("react");
var _useContextSelector = require("use-context-selector");
var _components = require("../../components");
var useFee = function useFee(_ref) {
  var isFormValid = _ref.isFormValid,
    blockchain = _ref.blockchain;
  var _useContext = (0, _react.useContext)(_components.CreateWithdrawContext),
    useCreateWithdraw = _useContext.useCreateWithdraw,
    useWithdrawFee = _useContext.useWithdrawFee;
  var _useCreateWithdraw = useCreateWithdraw(),
    withdrawState = _useCreateWithdraw.withdrawState;
  var amount = (0, _useContextSelector.useContextSelector)(_components.SendPageContext, function (state) {
    return state.amount;
  });
  var ticker = (0, _useContextSelector.useContextSelector)(_components.SendPageContext, function (state) {
    return state.ticker;
  });
  var address = (0, _useContextSelector.useContextSelector)(_components.SendPageContext, function (state) {
    return state.to;
  });
  var _ref2 = useWithdrawFee(),
    fetchWithdrawFee = _ref2.fetchWithdrawFee,
    withdrawFeeState = _ref2.withdrawFeeState,
    resetWithdrawFee = _ref2.resetWithdrawFee;
  (0, _react.useEffect)(function () {
    resetWithdrawFee();
  }, [amount, ticker, address, blockchain]);
  (0, _react.useEffect)(function () {
    return function () {
      resetWithdrawFee();
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (amount && blockchain && isFormValid && !withdrawFeeState.loading && !withdrawFeeState.value) {
      fetchWithdrawFee({
        ticker: ticker,
        amount: amount,
        blockchain: blockchain,
        address: address
      });
    }
  }, [amount, ticker, isFormValid, withdrawFeeState, blockchain, address]);
  (0, _react.useEffect)(function () {
    if (withdrawState.done) {
      resetWithdrawFee();
    }
  }, [withdrawState.done]);

  // fetch actual fee if current is less than required
  (0, _react.useEffect)(function () {
    if (withdrawState.feeLessThanRequired) fetchWithdrawFee({
      ticker: ticker,
      amount: amount,
      blockchain: blockchain,
      address: address
    });
  }, [withdrawState.feeLessThanRequired, ticker, amount, blockchain, address]);
  return {
    value: withdrawFeeState.value,
    converted: withdrawFeeState.converted
  };
};
exports.useFee = useFee;